import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Due to limited capabilities of traditional methods to reflect the depth of experiential qualities associated with spatial hearing, a more advanced custom methodologies have been proposed. One example is ADA method (developed by Dolby [No]) which allows for high-dimensional capture of subjective experiences of sound localization and quality. In this section, one of basic applications of ADA method is presented - evaluation of binaural audio system performance in the context of spatial localization.<br><center><h3>INDICATE THE PERCEIVED LOCATION FOR SYSTEM B</h3></center>",
  layout: {
    type: "table",

    options: {
      rows: 1,
      cols: 2,
      colsSize: [1, 2],
      components: [
        [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    theme: "default",
                    text: "System B",
                    icon: "cis-volume-high",
                    shape: "round",
                    size: "standard",
                    loop: true,
                    url: `${config.ASSETS_URL}/02/26/principle/system_b.mp3`,
                  },
                },
                styles: {
                  alignItems: "center",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "panner",
                  options: {
                    audio: [],
                    hideIcon: true,
                  },
                },
              },
            },
          ],
        ],
      ],
    },
  },
};

export default principle;
